import React from 'react';

const PageTitleUserInterface = () => {
    return (
        <div id="page-title">
            <div className="wrapper">
                <div className="title">
                    <h1 className="large">Malex user interface (UI)</h1>
                </div>

                <div className="title-opacity">
                    <div className="title-opacity-text">UI</div>
                </div>
            </div>
        </div>
    );
};

export default PageTitleUserInterface;
